/**
 * @module Routes
 *
 */
import React from 'react';
import { NavLink } from 'react-router-dom';
import { cls } from 'app/utils';
import upgrade_trial_jpg from 'app/images/upgrade-trial.jpg';
import Styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';

/**
 * @class ExpiredTrial
 *
 */
export default function ExpiredTrial() {
  const { t } = useTranslation();
  return (
    <div className={Styles.successMain}>
      <div className={cls(Styles.panel, Styles.panelOne)}>
        <div className={Styles.successImage} style={{ backgroundImage: `url(${upgrade_trial_jpg})` }} />
      </div>

      <div className={cls(Styles.panel, Styles.panelTwo)}>
        <div className={Styles.panelContainer}>
          <div className={Styles.panelHeader}>
            {t('Your 7-day Trial Has Expired')}
          </div>

          <div className={Styles.panelBody}>
            <p>{t("Thank you for trying out CoachNow PRO")}</p>
            <p className={Styles.highlight}>{t('Liked what you saw?')}</p>
            <p>{t('Upgrade now and keep access to unlimited Spaces and Teams, media posting and video/image analysis in Teams, 150GB of storage, Library, Segements, and Templates Tools.')}</p>
            <div className="clear-float"></div>
          </div>

          <div className={Styles.panelFooter}>
            <NavLink className={cls('btn', 'btn-outline-secondary', Styles.rowButton)} to="/">
              {t("Back")}
            </NavLink>
            <NavLink className={cls('btn', 'btn-primary', Styles.rowButton)} to="/upgrade">
              {t("Upgrade")}
            </NavLink>
          </div>

          <div className="clear-float"></div>
        </div>
      </div>
    </div>
  );
}
